export { UploadedLogo } from './UploadedLogo'
